import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import QueryTask from "@arcgis/core/tasks/QueryTask";
import Query from "@arcgis/core/rest/support/Query";

import Graphic from "@arcgis/core/Graphic";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Zoom from "@arcgis/core/widgets/Zoom";


function getPolygonSymbol(){
  const polygonSymbol = {
    type: "simple-fill",
    color: [150, 150, 150, 0.2],
    outline: {
      color: [50, 50, 50],
      width: 2
    }
  }
  return polygonSymbol;
}


export function addGraphicLayer(name, mapView) {
  let graphicLayer = getLayer(mapView, name + "graphicLayer");
  if (graphicLayer === undefined) {
    graphicLayer = new GraphicsLayer({
      id: name + "graphicLayer"
    });
    mapView.map.add(graphicLayer);
  }
  return graphicLayer;
}


export function getLayer(mapView, id) {
  let layer = mapView.map.layers.find(function (l) {
    return l.id === id;
  });
  return layer;
}

export function addGraphic(layer, feature, clear, imageUrl = null) {
  if (clear) {
    layer.removeAll();
  }
  let _geomerty = feature.geometry || feature;
  var graphic = new Graphic({
    geometry: _geomerty,
    attributes: feature.attributes || feature
  });
  switch (_geomerty.type) {
    case "polygon":
      graphic.symbol = getPolygonSymbol()
      break;
    case "point":
      graphic.symbol = imageSymbol(imageUrl)
      break;
  }
  layer.add(graphic);
}

export function addGraphicOnEdite(layer, feature, clear, imageUrl = null) {
  if (clear) {
    layer.removeAll();
  }
  let _geomerty = feature.geometry.centroid || feature;
  var graphic = new Graphic({
    geometry: _geomerty,
    attributes: feature.attributes || feature
  });
  switch (_geomerty.type) {
    case "polygon":
      graphic.symbol = getPolygonSymbol()
      break;
    case "point":
      graphic.symbol = imageSymbol(imageUrl)
      break;
  }
  layer.add(graphic);
}

export const queryMode = {
  Features: "Features",
  ObjectIds: "ObjectIds",
  FeatureCount: "FeatureCount"
}

export function queryTaskAsync(options) {
  let queryTask = new QueryTask({
    url: options.url
  });
  let query = new Query();
  if (options.geometry != undefined) {
    query.geometry = options.geometry;
  }
  if (options.spatialRelationship != undefined) {
    query.spatialRelationship = options.spatialRelationship;
  }
  if (options.num != undefined) {
    query.num = options.num;
  }
  if (options.start != undefined) {
    query.start = options.start;
  }
  
  if (options.units) {
    query.units = options.units;
  }

  if (options.distance) {
    query.distance = options.distance;
  }

  query.returnDistinctValues = options.returnDistinctValues ? options.returnDistinctValues : false;
  query.returnGeometry = options.returnGeometry != null ? options.returnGeometry : true;
  query.objectIds = options.objectIds ? options.objectIds : [];
  query.outFields = options.outFields ? options.outFields : ["*"];
  query.where = options.where == "" ? "1=1" : options.where;
  query.orderByFields = options.orderByFields ? options.orderByFields : [];
  query.start = options.start == "" ? undefined : options.start;
  query.num = options.num == "" ? undefined : options.num;
  switch (options.mode.toLowerCase()) {
    case queryMode.Features.toLowerCase():
      return queryTask.execute(query);
    case queryMode.ObjectIds.toLowerCase():
      return queryTask.executeForIds(query);
    case queryMode.FeatureCount.toLowerCase():
      return queryTask.executeForCount(query);
  }
}


export function zoomToFeature(geometry, mapView, duration = 1000, easing = "out-quint") {
  let options = {
    duration: duration,
    easing: easing
  };
  mapView != undefined ? mapView.goTo({ target: geometry }, options) : alert('check mapView');
  console.log(geometry);
}

export const centerAndZoom = (mapView, event, zoomlevel) => {
  let options = {
    duration: "500",
    speedFactor: 0.2, // animation is 10 times slower than default
    easing: "out-quint" // easing function to slow down when reaching the target
  };
  mapView.goTo({ target: event.mapPoint, zoom: zoomlevel }, options)
}

export function addGraphicToMap(feature, mapView) {
  if (mapView && mapView.graphics.length > 0) {
    mapView.graphics.removeAll();
  }
  let _geomerty = feature.geometry || feature;
  var graphic = new Graphic({
    geometry: _geomerty,
    attributes: feature.attributes || feature
  });
  switch (_geomerty.type) {
    case "polygon":
      graphic.symbol = polylineSymbol()
      break;
    case "polyline":
      graphic.symbol = polylineSymbol()
      break;
  }
  mapView != undefined ? mapView.graphics.add(graphic) : null;
}

export function polylineSymbol() {
  var symbol = {
    type: "simple-line",
    color: "red",
    width: "2px",
    style: "solid"
  };
  return symbol;
}

export function imageSymbol(imgUrl){
  let symbol = {
    type: "picture-marker",
    url: imgUrl,
    width: "35px",
    height: "35px"
  };
  return symbol;
}

export function addFeatureLayer(layerURL) {
  let featureLayer = new FeatureLayer({
    url: layerURL,
    outFields: ["*"]
  });
  return featureLayer;
}


export function deleteFeature(objectId, featurelayer, successCallback, errorCallback) {
  const feature = {
    objectId: objectId
  };
  const deleteFeature = {
    deleteFeatures: [feature]
  }
  featurelayer.applyEdits(deleteFeature).then(function (results) {
    if (results.deleteFeatureResults.length > 0) {
      successCallback(results.deleteFeatureResults[0])
    } else {
      errorCallback();
    }
  }).catch(function (error) {
    errorCallback(error);
  });
}


export function createElement(elType, options) {
  let el = document.createElement(elType);
  el.className = options.className;
  el.id = options.id;
  el.value = options.value;
  el.title = options.title;
  return el;
}


export const setFeatureLayerExpression = (featureLayer, expression) => {
  return featureLayer.definitionExpression = expression;
}

export function distanceBetweeanGeometry(geometry1, geometry2) {
  return geometryEngine.distance(geometry1, geometry2);
}


export const ZoomOut = async (view) => {
  var zoom = new Zoom({
    view: view,
  });
  zoom.zoomOut();
}


export const groupBy = (list, key) => {
  return list.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};